import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "../lib/i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mw_lang") || "hi");
  const toggle = useCallback(() => {
    setLang((l) => {
      const next = l === "hi" ? "en" : "hi";
      localStorage.setItem("mw_lang", next);
      return next;
    });
  }, []);
  const t = useCallback((key) => translations[lang][key] ?? translations.en[key] ?? key, [lang]);
  return <LangContext.Provider value={{ lang, toggle, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
